// extracted by mini-css-extract-plugin
export var body = "_kt-0";
export var sectionHeader = "_kt-4";
export var shortcutColumns = "_kt-2";
export var shortcutList = "_kt-1";
export var shortcutSection = "_kt-3";